import { useState, useEffect } from "react";
import axios from "axios";

import { getGlobalVar, setGlobalVar } from "../../config/Config";

//? Item Component --Child of Create Order
const Item = ({
  item,
  itemsInCart,
  setItemsInCart,
  calVal,
  selectedItemId,
  setSelectedItemId,
  imgUrl,
  setTotal,
  total,
}) => {
  const USER = JSON.parse(localStorage.getItem("auth"));
  const org = "?org=" + USER?.org;
  const [itemValue, setItemValue] = useState(item.quantity);
  const [isDiscountApplied, setIsDiscountApplied] = useState(item.discount > 0);
  const [totalPrice, setTotalPrice] = useState(0);
  const [globalVar, setValue] = useState(getGlobalVar());
  const OrderedProductAPI = globalVar.url + "/posapi/CreateOrder/";
  const GetOrderedProducts =
    globalVar.url + "/posapi/GetOrderedProducts" + org + "&order_ref=";
  useEffect(() => {
    const price = item.price || item.SalesPrice;
    const discount = item.discount || 0;
    const quantity = item.quantity || itemValue;

    let calculatedPrice = 0;

    if (price) {
      calculatedPrice = price * quantity;
      if (discount) {
        calculatedPrice -= (calculatedPrice * discount) / 100;
      }
    } else if (discount) {
      // If there is a discount but no price, use a default price for calculation
      calculatedPrice = 1 * quantity; // Assuming price per unit as 1 for calculations
      calculatedPrice -= (calculatedPrice * discount) / 100;
    } else {
      // If neither price nor discount, show total based on default logic (e.g., quantity only)
      calculatedPrice = price * quantity;
    }

    setTotalPrice(!isNaN(calculatedPrice) ? calculatedPrice.toFixed(2) : 0);
  }, [itemValue, item.price, item.discount, item.quantity]);

  // Handle discount application
  const handleApplyDiscount = () => {
    setIsDiscountApplied(true);
  };

  const recalculateTotal = () => {
    const newTotal = itemsInCart.reduce((acc, item) => {
      const price = item.price || item.SalesPrice; // depending on your logic for price vs price
      const discount = item.discount || 0;
      return acc + (price - discount) * item.quantity;
    }, 0);

    setTotal(newTotal); // Update the total state
  };
  // Handle quantity change
  // const handleQuantityChange = (productId, newQuantity) => {
  //   setItemsInCart(prevItems =>
  //     prevItems.map(item =>
  //       item.id === productId ? { ...item, quantity: newQuantity } : item
  //     )
  //   );
  //   recalculateTotal();
  // };

  //! Cart items Delete
  const onItemInCartDelete = async (id) => {
    try {
      const orderRef = localStorage.getItem("actualOrderId");

      if (!orderRef) {
        console.error("Order reference not found");
        return;
      }

      // Fetch ordered products to get the orderedProductId
      const orderedProductsResponse = await axios.get(
        `${GetOrderedProducts}${orderRef}`,
        {
          headers: {
            Authorization: "Bearer " + globalVar.Token,
          },
        }
      );

      const orderedProduct = orderedProductsResponse.data.find(
        (orderedProduct) => orderedProduct.product.id === id
      );

      if (orderedProduct) {
        // Delete the ordered product using its ID
        await axios.patch(
          `${OrderedProductAPI}${orderedProduct.id}/` + org,
          {
            is_archive: true,
          },
          {
            headers: {
              Authorization: "Bearer " + globalVar.Token,
            },
          }
        );

        // Remove the deleted item from the cart
        const updatedCartItems = itemsInCart.filter((item) => item.id !== id);
        setItemsInCart(updatedCartItems);
        console.log(id, "deleted from cart and backend");
      } else {
        console.error("Ordered product not found for deletion");
        const deleted = itemsInCart.filter((item) => item.id !== id);
        setItemsInCart(deleted);
        console.log(deleted, "deleted");
      }
    } catch (error) {
      console.error(
        "Error deleting ordered product:",
        error.response ? error.response.data : error.message
      );
    }
  };

  // Selected order
  const onItemInCartClick = (id) => {
    console.log(id, "id");
    //   console.log(item.price)
    console.log(itemsInCart);

    setSelectedItemId(id);
    console.log(selectedItemId, "selected");
  };

  return (
    <>
      <div className="item-cart-main mt-1 ml-2 ">
        <div
          className={`item-cart-sec ${
            selectedItemId === item.id ? "selected" : ""
          }`}
        >
          <button
            className={`item-cart-btn-main flex border-none`}
            key={item.id}
            onClick={() => {
              onItemInCartClick(item.id);
              handleApplyDiscount();
            }}
          >
            <li key={item.id} className="border-2 p-1 m-1 h-fit">
              <img src={item.Photo} alt={item.ProductName} />
              <div className="image-name">{item.ProductName}</div>
              <br />
              <div className="product-details">
                <span>Rs {item.price ?? item.SalesPrice} /unit</span>
              </div>
              {item.discount > 0 && (
                <div className="product-details">
                  <span>With a {item.discount}% discount</span>
                </div>
              )}
              {/* {item.price > 0 && (
        <p>
          price: {item.price}
        </p>
      )} */}
              <br />
              <div className="product-details">
                <span className="">QTY : {item.quantity}</span>
              </div>
              <br />
              <div className="product-details">
                {/* <span>Amount: {totalPrice}</span> */}
              </div>
              <div className="products-notes">
                <div className="product-details">
                  {item.internalNote && (
                    <span>Internal Note: {item.internalNote}</span>
                  )}
                </div>
                <div className="product-details">
                  {item.customerNote && (
                    <span>Customer Note: {item.customerNote}</span>
                  )}
                </div>
              </div>
            </li>
          </button>
          <div className="close-btn">
            <button
              onClick={() => {
                onItemInCartDelete(item.id);
              }}
              className=""
            >
              x
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Item;
